import { html } from '../../mixins/katapult-element.js';
import { KatapultEditorTemplate } from './katapult-editor-template.js';
import { PortalStyle } from './katapult-model-editor-style.js';
import randomColor from '../../modules/_deprecated/RandomColor.js';
import '../katapult-elements/katapult-button.js';
import '../katapult-elements/katapult-icon.js';
import '../katapult-drop-down/katapult-drop-down.js';

import '../paper-header/paper-header.js';
import { safeHtml } from 'common-tags';
import { DEFAULT_SCHEMAS } from '../../modules/KLogicSchemas.js';
import { serverTimestamp } from 'firebase/database';
import { confirmSyncPortalConfig, syncPortalConfigs } from './SyncedPortalConfigHelpers.js';

customElements.define(
  'katapult-portal-user-options-editor',
  class extends KatapultEditorTemplate {
    static get template() {
      return html`
        ${super.style} ${PortalStyle}

        <style>
          .label-item {
            display: flex;
            align-items: center;
            gap: 2px;
            background-color: white;
            border: 1px solid var(--primary-text-color-faded);
            padding: 2px 4px 2px 8px;
            border-radius: 8px;
          }
          .short-dropdown {
            --katapult-drop-down-input: {
              --paper-input-container_-_padding: 0;
            };
          }
        </style>

        <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}">
        </katapult-firebase-worker>

        <katapult-dialog-legacy id="limitsDialog" title="Shared Attacher Limits" icon="groups" backdrop close-button>
          <paper-table slot="body" rounded outline white dividers overflow-hidden>
            <!-- Body -->
            <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.shared_attacher_limits.*)]]" mutable-data>
              <paper-row>
                <paper-cell>
                  <paper-input
                    label="Name"
                    value="[[item.name]]"
                    data-path="_itemData.shared_attacher_limits.$(model.item.$key).name"
                    no-label-float
                    on-value-changed="updateProperty"
                  ></paper-input>
                </paper-cell>
                <paper-cell icon-button>
                  <katapult-button
                    iconOnly
                    noBorder
                    icon="delete"
                    data-path="_itemData.shared_attacher_limits.$(model.item.$key)"
                    data-value="$null"
                    on-click="updateProperty"
                  ></katapult-button>
                </paper-cell>
              </paper-row>
            </template>
            <!-- Add Button -->
            <paper-row class="addButton" ripple light-grey short data-path="_itemData.shared_attacher_limits" on-click="addOrderedItem">
              <paper-cell icon>
                <material-icon icon="playlist_add"></material-icon>
              </paper-cell>
              <paper-cell justify-center>
                <div>Add a Shared Attacher Limit</div>
              </paper-cell>
            </paper-row>
          </paper-table>
        </katapult-dialog-legacy>

        <katapult-firebase-worker path="photoheight/companies" data="{{companies}}"></katapult-firebase-worker>

        <katapult-firebase-worker
          path="utility_info/[[config.firebaseData.utilityCompany]]/attachers"
          data="{{attachers}}"
        ></katapult-firebase-worker>

        <katapult-firebase-worker
          path="users/[[config.firebaseData.utilityCompany]]"
          data="{{utilityCompanyUsers}}"
        ></katapult-firebase-worker>

        <paper-table class="settings-table">
          <!-- Allow Drafts Before Approval -->
          <paper-row checkbox pointer align-center>
            <paper-cell icon>
              <material-icon icon="content_paste"></material-icon>
            </paper-cell>
            <paper-cell shrink>Allow Drafts Before Approval</paper-cell>
            <paper-cell icon>
              <paper-checkbox
                checked="[[_itemData.allow_drafts_before_approval]]"
                data-path="_itemData.allow_drafts_before_approval"
                on-change="toggleProperty"
              ></paper-checkbox>
            </paper-cell>
            <paper-cell italic>Should applicants be allowed to create application drafts before approval?</paper-cell>
          </paper-row>
          <!-- Submission Window Length -->
          <paper-row input align-center>
            <paper-cell icon>
              <material-icon icon="date_range"></material-icon>
            </paper-cell>
            <paper-cell shrink>Submission Window Length</paper-cell>
            <paper-cell style="max-width: 120px;">
              <paper-input
                type="number"
                value="[[_itemData.submission_window_length]]"
                data-path="_itemData.submission_window_length"
                no-label-float
                underline
                on-value-changed="updateTopLevelInput"
              >
                <span slot="suffix">days</span>
              </paper-input>
            </paper-cell>
            <paper-cell italic>How long should the pole submission window be?</paper-cell>
          </paper-row>
          <!-- Submission Window Limit -->
          <paper-row input align-center>
            <paper-cell icon>
              <material-icon icon="tag"></material-icon>
            </paper-cell>
            <paper-cell shrink>Default Submission Window Limit</paper-cell>
            <paper-cell style="max-width: 120px;">
              <paper-input
                type="number"
                value="[[_itemData.submission_window_limit]]"
                data-path="_itemData.submission_window_limit"
                no-label-float
                underline
                on-value-changed="updateTopLevelInput"
              >
                <span slot="suffix">poles</span>
              </paper-input>
            </paper-cell>
            <paper-cell italic>The maximum number of poles a company can submit for within the submission window</paper-cell>
          </paper-row>
          <!-- Prevent Application Submission -->
          <paper-row checkbox pointer align-center>
            <paper-cell icon>
              <material-icon icon="block"></material-icon>
            </paper-cell>
            <paper-cell shrink>Prevent Applications once Submission Window Limit has been Reached</paper-cell>
            <paper-cell shrink>
              <paper-checkbox
                checked="[[_itemData.submission_window_prevent_new_applications]]"
                data-path="_itemData.submission_window_prevent_new_applications"
                on-change="toggleProperty"
              ></paper-checkbox>
            </paper-cell>
            <paper-cell italic
              >Should applicants be prevented from submitting new applications once the submission window limit has been reached?
              <br /><br />If left unchecked, additional applications will be allowed, but with potentially longer timelines.</paper-cell
            >
          </paper-row>
          <!-- Utility Admin Strategy -->
          <paper-row align-center>
            <paper-cell icon>
              <material-icon icon="view_quilt"></material-icon>
            </paper-cell>
            <paper-cell shrink>Utility Admin Strategy</paper-cell>
            <paper-cell style="flex-basis: unset; flex-grow: unset;">
              <div>
                <katapult-drop-down
                  style="width: 240px;"
                  no-label-float
                  items="[[optionsForAppAdministration]]"
                  label-path="label"
                  value-path="value"
                  value="[[_itemData.admin_strategy]]"
                  data-path="_itemData.admin_strategy"
                  on-value-changed="updateProperty"
                ></katapult-drop-down>
              </div>
            </paper-cell>
            <paper-cell italic>Strategy for dividing application administration among utility users</paper-cell>
          </paper-row>
          <!-- Companies with Full Map View -->
          <paper-row expand>
            <div flex grow style="padding: 12px; gap: 24px;">
              <material-icon icon="public"></material-icon>
              <div flex column grow style="gap: 12px;">
                <div flex align-center style="height: 24px;">Companies with Full Map View</div>
                <div>
                  Companies that are able to see all poles in the utility company's service area. Ordinarily, companies can only see poles
                  within a certain distance of the poles they are applying for.
                </div>
                <paper-table rounded white outline grow overflow-hidden dividers style="width: 600px;">
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getItemsArray(_itemData.full_map_view_companies.*)]]" mutable-data>
                    <paper-row>
                      <paper-cell>[[getSub(companies, item.$key, 'name')]]</paper-cell>
                      <paper-cell icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.full_map_view_companies.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                    </paper-row>
                  </template>
                  <!-- Add Drop Down -->
                  <paper-row>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select a Company"
                        value="[[item.$key]]"
                        items="[[companies]]"
                        value-path="$key"
                        label-path="name"
                        no-label-float
                        data-path="_itemData.full_map_view_companies.$(detail.value)"
                        data-value="$true"
                        on-selected-changed="selectedChangedCallback"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </div>
          </paper-row>
          <!-- Review Contractors -->
          <paper-row expand>
            <div flex grow style="padding: 12px; gap: 24px;">
              <material-icon icon="engineering"></material-icon>
              <div flex column grow style="gap: 12px;">
                <div flex align-center style="height: 24px;">Review Contractors</div>
                <div>
                  Companies that can be added as review contractors on applications in the portal. Companies from this list are added as
                  review contractors (with write permission) when:
                  <ul style="line-height: 1.5">
                    <li>The "Add Review Contractor" action is run on the application, and</li>
                    <li>The "Assignment Function" set below returns true for the application (with access to the app's metadata)</li>
                  </ul>
                </div>
                <div flex align-center style="gap: 8px;">
                  <katapult-icon icon="sync" size="small"></katapult-icon>
                  <div>
                    These contractors auto-populate the default picklist of the
                    <a href$="[[_getAttributeLink(modelSpaceDetails.$key, 'review_contractor')]]" target="_blank" class="highlighted-link"
                      >Review Contractor</a
                    >
                    attribute.
                  </div>
                </div>
                <paper-table rounded white outline grow overflow-hidden dividers>
                  <!-- Header -->
                  <paper-row grey short>
                    <paper-cell>Company Name</paper-cell>
                    <paper-cell icon></paper-cell>
                  </paper-row>
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getItemsArray(_itemData.review_contractors.*)]]" mutable-data>
                    <paper-header-content
                      data-path="_itemData.review_contractors.$(model.item.$key)"
                      on-opened-changed="updateProperty"
                      on-render-changed="updateProperty"
                      opened="[[item.$opened]]"
                      divider
                      no-click-row
                    >
                      <paper-cell slot="header" input>[[getSub(companies, item.$key, 'name')]]</paper-cell>
                      <paper-cell slot="header-end" icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.review_contractors.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                      <template is="dom-if" if="[[item.$render]]" restamp>
                        <div class="settings-table" slot="content" flex column>
                          <paper-row>
                            <paper-cell icon>
                              <material-icon icon="functions"></material-icon>
                            </paper-cell>
                            <paper-cell shrink>Assignment Function</paper-cell>
                            <paper-cell>
                              <k-logic-editor
                                block="[[item.assignment_function]]"
                                schema="[[_klogicSchemas.contractorAssignment]]"
                                data-path="_itemData.review_contractors.$(model.item.$key).assignment_function"
                                on-block-changed="updateProperty"
                              ></k-logic-editor>
                            </paper-cell>
                          </paper-row>
                          <paper-row>
                            <paper-cell icon>
                              <material-icon icon="low_priority"></material-icon>
                            </paper-cell>
                            <paper-cell shrink>Use as Fallback Review Contractor</paper-cell>
                            <paper-cell icon>
                              <paper-checkbox
                                checked="[[item.is_fallback_contractor]]"
                                data-path="_itemData.review_contractors.$(model.item.$key).is_fallback_contractor"
                                on-change="toggleProperty"
                              ></paper-checkbox>
                            </paper-cell>
                            <paper-cell italic
                              >Assign this company as a review contractor if no company's assignment function applies.</paper-cell
                            >
                          </paper-row>
                          <paper-row style="align-items: center;">
                            <paper-cell icon>
                              <katapult-icon icon="map"></katapult-icon>
                            </paper-cell>
                            <paper-cell shrink>Deployment Map Job</paper-cell>
                            <paper-cell>
                              <paper-input
                                label="Deployment Map Job Id"
                                no-label-float
                                underline
                                value="[[item.deployment_map_config.job_id]]"
                                data-path="_itemData.review_contractors.$(model.item.$key).deployment_map_config.job_id"
                                on-value-changed="updateProperty"
                              ></paper-input>
                            </paper-cell>
                          </paper-row>
                          <paper-row style="align-items: center;">
                            <paper-cell icon>
                              <katapult-icon icon="filter"></katapult-icon>
                            </paper-cell>
                            <paper-cell shrink>Deployment Map Filter</paper-cell>
                            <paper-cell>
                              <k-logic-editor
                                block="[[item.deployment_map_config.job_filter]]"
                                schema="[[_klogicSchemas.deploymentMap]]"
                                data-path="_itemData.review_contractors.$(model.item.$key).deployment_map_config.job_filter"
                                on-block-changed="updateProperty"
                              ></k-logic-editor>
                            </paper-cell>
                          </paper-row>
                        </div>
                      </template>
                    </paper-header-content>
                  </template>
                  <!-- Add Drop Down -->
                  <paper-row>
                    <paper-cell>
                      <katapult-drop-down
                        label="Add a Company"
                        value="[[item.$key]]"
                        items="[[companies]]"
                        value-path="$key"
                        label-path="name"
                        no-label-float
                        data-path="_itemData.review_contractors.$(detail.value)"
                        on-selected-changed="addObjectItem"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </div>
          </paper-row>
          <!-- Engineering Contractors -->
          <paper-row expand>
            <div flex grow style="padding: 12px; gap: 24px;">
              <material-icon icon="architecture"></material-icon>
              <div flex column grow style="gap: 12px;">
                <div flex align-center style="height: 24px;">Engineering Contractors</div>
                <div>
                  Companies that can be added as engineering contractors on applications in the portal. Companies from this list are added
                  as engineering contractors (with write permission) when:
                  <ul style="line-height: 1.5">
                    <li>The "Add Engineering Contractor" action is run on the application, and</li>
                    <li>The "Assignment Function" set below returns true for the application (with access to the app's metadata)</li>
                  </ul>
                  Write access may subsequently be removed by the "Update Contractor Sharing" action with the "Remove engineering contractor
                  write access" option selected.
                </div>
                <div flex align-center style="gap: 8px;">
                  <katapult-icon icon="sync" size="small"></katapult-icon>
                  <div>
                    These contractors auto-populate the default picklist of the
                    <a
                      href$="[[_getAttributeLink(modelSpaceDetails.$key, 'engineering_contractor')]]"
                      target="_blank"
                      class="highlighted-link"
                      >Engineering Contractor</a
                    >
                    attribute.
                  </div>
                </div>
                <paper-table rounded white outline grow overflow-hidden dividers>
                  <!-- Header -->
                  <paper-row grey short>
                    <paper-cell>Company Name</paper-cell>
                    <paper-cell icon></paper-cell>
                  </paper-row>
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getItemsArray(_itemData.engineering_contractors.*)]]" mutable-data>
                    <paper-header-content
                      data-path="_itemData.engineering_contractors.$(model.item.$key)"
                      on-opened-changed="updateProperty"
                      on-render-changed="updateProperty"
                      opened="[[item.$opened]]"
                      divider
                      no-click-row
                    >
                      <paper-cell slot="header" input>[[getSub(companies, item.$key, 'name')]]</paper-cell>
                      <paper-cell slot="header-end" icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.engineering_contractors.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                      <template is="dom-if" if="[[item.$render]]" restamp>
                        <div class="settings-table" slot="content" flex column>
                          <paper-row>
                            <paper-cell icon>
                              <material-icon icon="functions"></material-icon>
                            </paper-cell>
                            <paper-cell shrink>Assignment Function</paper-cell>
                            <paper-cell>
                              <k-logic-editor
                                block="[[item.assignment_function]]"
                                schema="[[_klogicSchemas.contractorAssignment]]"
                                data-path="_itemData.engineering_contractors.$(model.item.$key).assignment_function"
                                on-block-changed="updateProperty"
                              ></k-logic-editor>
                            </paper-cell>
                          </paper-row>
                          <paper-row>
                            <paper-cell icon>
                              <material-icon icon="low_priority"></material-icon>
                            </paper-cell>
                            <paper-cell shrink>Use as Fallback Engineering Contractor</paper-cell>
                            <paper-cell icon>
                              <paper-checkbox
                                checked="[[item.is_fallback_contractor]]"
                                data-path="_itemData.engineering_contractors.$(model.item.$key).is_fallback_contractor"
                                on-change="toggleProperty"
                              ></paper-checkbox>
                            </paper-cell>
                            <paper-cell italic
                              >Assign this company as an engineering contractor if no company's assignment function applies.</paper-cell
                            >
                          </paper-row>
                        </div>
                      </template>
                    </paper-header-content>
                  </template>
                  <!-- Add Drop Down -->
                  <paper-row>
                    <paper-cell>
                      <katapult-drop-down
                        label="Add a Company"
                        value="[[item.$key]]"
                        items="[[companies]]"
                        value-path="$key"
                        label-path="name"
                        no-label-float
                        data-path="_itemData.engineering_contractors.$(detail.value)"
                        on-selected-changed="addObjectItem"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </div>
          </paper-row>
          <!-- Data Collection Contractors -->
          <paper-row expand>
            <div flex grow style="padding: 12px; gap: 24px;">
              <material-icon icon="photo_camera"></material-icon>
              <div flex column grow style="gap: 12px;">
                <div flex align-center style="height: 24px;">Data Collection Contractors</div>
                <div>
                  Companies that can be added as data collection contractors on applications in the portal. Companies from this list are
                  added as data collection contractors (with write permission) when:
                  <ul style="line-height: 1.5">
                    <li>The "Add Data Collection Contractor" action is run on the application, and</li>
                    <li>The "Assignment Function" set below returns true for the application (with access to the app's metadata)</li>
                  </ul>
                  Write access may subsequently be removed by the "Update Contractor Sharing" action with the "Remove data collection
                  contractor write access" option selected.
                </div>
                <div flex align-center style="gap: 8px;">
                  <katapult-icon icon="sync" size="small"></katapult-icon>
                  <div>
                    These contractors auto-populate the default picklist of the
                    <a
                      href$="[[_getAttributeLink(modelSpaceDetails.$key, 'data_collection_contractor')]]"
                      target="_blank"
                      class="highlighted-link"
                      >Data Collection Contractor</a
                    >
                    attribute.
                  </div>
                </div>
                <paper-table rounded white outline grow overflow-hidden dividers>
                  <!-- Header -->
                  <paper-row grey short>
                    <paper-cell>Company Name</paper-cell>
                    <paper-cell icon></paper-cell>
                  </paper-row>
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getItemsArray(_itemData.data_collection_contractors.*)]]" mutable-data>
                    <paper-header-content
                      data-path="_itemData.data_collection_contractors.$(model.item.$key)"
                      on-opened-changed="updateProperty"
                      on-render-changed="updateProperty"
                      opened="[[item.$opened]]"
                      divider
                      no-click-row
                    >
                      <paper-cell slot="header" input>[[getSub(companies, item.$key, 'name')]]</paper-cell>
                      <paper-cell slot="header-end" icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.data_collection_contractors.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                      <template is="dom-if" if="[[item.$render]]" restamp>
                        <div class="settings-table" slot="content" flex column>
                          <paper-row>
                            <paper-cell icon>
                              <material-icon icon="functions"></material-icon>
                            </paper-cell>
                            <paper-cell shrink>Assignment Function</paper-cell>
                            <paper-cell>
                              <k-logic-editor
                                block="[[item.assignment_function]]"
                                schema="[[_klogicSchemas.contractorAssignment]]"
                                data-path="_itemData.data_collection_contractors.$(model.item.$key).assignment_function"
                                on-block-changed="updateProperty"
                              ></k-logic-editor>
                            </paper-cell>
                          </paper-row>
                          <paper-row>
                            <paper-cell icon>
                              <material-icon icon="low_priority"></material-icon>
                            </paper-cell>
                            <paper-cell shrink>Use as Fallback Data Collection Contractor</paper-cell>
                            <paper-cell icon>
                              <paper-checkbox
                                checked="[[item.is_fallback_contractor]]"
                                data-path="_itemData.data_collection_contractors.$(model.item.$key).is_fallback_contractor"
                                on-change="toggleProperty"
                              ></paper-checkbox>
                            </paper-cell>
                            <paper-cell italic
                              >Assign this company as a data collection contractor if no company's assignment function applies.</paper-cell
                            >
                          </paper-row>
                        </div>
                      </template>
                    </paper-header-content>
                  </template>
                  <!-- Add Drop Down -->
                  <paper-row>
                    <paper-cell>
                      <katapult-drop-down
                        label="Add a Company"
                        value="[[item.$key]]"
                        items="[[companies]]"
                        value-path="$key"
                        label-path="name"
                        no-label-float
                        data-path="_itemData.data_collection_contractors.$(detail.value)"
                        on-selected-changed="addObjectItem"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </div>
          </paper-row>
          <!-- Attacher Settings -->
          <paper-row expand>
            <div flex grow style="padding: 12px; gap: 24px;">
              <katapult-icon icon="manage_accounts"></katapult-icon>
              <div flex column grow style="gap: 12px;">
                <div flex align-center style="height: 24px;">Attacher Settings</div>
                <div>Settings that apply to specific attacher companies.</div>
                <paper-table rounded white outline grow overflow-hidden dividers>
                  <!-- Header -->
                  <paper-row grey short>
                    <paper-cell>Company Name</paper-cell>
                    <paper-cell icon></paper-cell>
                  </paper-row>
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getItemsArray(_itemData.attacher_settings.*)]]" mutable-data>
                    <paper-header-content
                      data-path="_itemData.attacher_settings.$(model.item.$key)"
                      on-opened-changed="updateProperty"
                      on-render-changed="updateProperty"
                      opened="[[item.$opened]]"
                      divider
                      no-click-row
                    >
                      <paper-cell slot="header" input>[[getSub(attachers, item.$key, 'name')]]</paper-cell>
                      <paper-cell slot="header-end" icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.attacher_settings.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                      <template is="dom-if" if="[[item.$render]]" restamp>
                        <div class="settings-table" slot="content" flex column>
                          <paper-row>
                            <paper-cell icon>
                              <katapult-icon icon="tune"></katapult-icon>
                            </paper-cell>
                            <paper-cell shrink>Custom Attacher Pole Limit</paper-cell>
                            <paper-cell style="max-width: 200px; gap: 8px;">
                              <!-- TODO: The whole page scrolls when you try to use the wheel to set this number... boo -->
                              <paper-input
                                label="Custom Limit"
                                class="short-input"
                                type="number"
                                no-label-float
                                underline
                                value="[[item.custom_pole_limit]]"
                                data-path="_itemData.attacher_settings.$(model.item.$key).custom_pole_limit"
                                on-value-changed="updateProperty"
                              ></paper-input>
                              <katapult-icon
                                icon="clear"
                                data-path="_itemData.attacher_settings.$(model.item.$key).custom_pole_limit"
                                data-value="$null"
                                on-click="updateProperty"
                              ></katapult-icon>
                            </paper-cell>
                            <paper-cell italic
                              >Override the default submission window pole limit ([[firstValid(_itemData.submission_window_limit, 'not
                              set')]]) for this attacher company.</paper-cell
                            >
                          </paper-row>
                          <paper-row>
                            <paper-cell icon>
                              <katapult-icon icon="label"></katapult-icon>
                            </paper-cell>
                            <paper-cell shrink>Attacher Labels</paper-cell>
                            <paper-cell column align-start style="gap: 8px;">
                              <div flex align-center style="gap: 24px;">
                                <paper-input
                                  label="New Label"
                                  class="short-input"
                                  no-label-float
                                  style="max-width: 200px;"
                                  data-path="_itemData.attacher_settings.$(model.item.$key).labels"
                                  on-keydown="handleLabelInputKeydown"
                                  title='Type a label and hit "Enter" to add it'
                                ></paper-input>
                                <div italic>Add custom labels to group and organize attachers.</div>
                              </div>
                              <div flex style="gap: 4px;">
                                <template is="dom-repeat" items="[[item.labels]]" as="attacherLabel" mutable-data>
                                  <div class="label-item" style$="[[_computeLabelItemStyle(attacherLabel)]]">
                                    <div>[[attacherLabel]]</div>
                                    <katapult-icon
                                      icon="clear"
                                      size="small"
                                      style="cursor: pointer;"
                                      data-path="_itemData.attacher_settings.$(model.parentModel.item.$key).labels"
                                      on-click="removeArrayItem"
                                    ></katapult-icon>
                                  </div>
                                </template>
                                <template is="dom-if" if="[[!item.labels.length]]">
                                  <div italic>(No labels have been added)</div>
                                </template>
                              </div>
                            </paper-cell>
                          </paper-row>
                          <paper-row>
                            <paper-cell icon>
                              <katapult-icon icon="supervisor_account"></katapult-icon>
                            </paper-cell>
                            <paper-cell shrink>Attacher Utility Admins</paper-cell>
                            <paper-cell column align-start style="gap: 8px;">
                              <div flex align-center style="gap: 24px;">
                                <katapult-drop-down
                                  items="[[utilityCompanyUsers]]"
                                  value-path="$key"
                                  label="Select User"
                                  label-path="email"
                                  select-on-focus
                                  no-label-float
                                  show-last-results
                                  class="short-dropdown"
                                  prevent-selection
                                  data-path="_itemData.attacher_settings.$(model.item.$key).utility_admins"
                                  on-selected-will-change="handleAdminSelected"
                                ></katapult-drop-down>
                                <div italic>Assign utility company admins to manage apps from this attacher.</div>
                              </div>
                              <div flex style="gap: 4px;">
                                <template is="dom-repeat" items="[[item.utility_admins]]" as="attacherUtilityAdmin" mutable-data>
                                  <div class="label-item" style$="[[_computeLabelItemStyle(attacherUtilityAdmin)]]">
                                    <div>[[getSub(utilityCompanyUsers, attacherUtilityAdmin, 'email')]]</div>
                                    <katapult-icon
                                      icon="clear"
                                      size="small"
                                      style="cursor: pointer;"
                                      data-path="_itemData.attacher_settings.$(model.parentModel.item.$key).utility_admins"
                                      on-click="removeArrayItem"
                                    ></katapult-icon>
                                  </div>
                                </template>
                                <template is="dom-if" if="[[!item.utility_admins.length]]">
                                  <div italic>(No utility admins have been added)</div>
                                </template>
                              </div>
                            </paper-cell>
                          </paper-row>
                        </div>
                      </template>
                    </paper-header-content>
                  </template>
                  <!-- Add Drop Down -->
                  <paper-row>
                    <paper-cell>
                      <katapult-drop-down
                        label="Add a Company"
                        value="[[item.$key]]"
                        items="[[attachers]]"
                        value-path="$key"
                        label-path="name"
                        no-label-float
                        data-path="_itemData.attacher_settings.$(detail.value)"
                        on-selected-changed="addObjectItem"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </div>
          </paper-row>
          <!-- Shared Pole Limit -->
          <paper-row expand>
            <div flex grow style="padding: 12px; gap: 24px;">
              <material-icon icon="groups"></material-icon>
              <div flex column grow style="gap: 12px;">
                <div flex align-center style="height: 24px;">Shared Pole Limit</div>
                <div>Attachment owner companies whose submissions should be counted against a shared pole limit (a "parent" company).</div>
                <paper-table rounded white outline grow overflow-hidden dividers>
                  <!-- Header -->
                  <paper-row grey short>
                    <paper-cell>Company Name</paper-cell>
                    <paper-cell>Shared Attacher Limit</paper-cell>
                    <paper-cell icon></paper-cell>
                  </paper-row>
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getItemsArray(_itemData.company_shared_pole_limit.*)]]" mutable-data>
                    <paper-row>
                      <paper-cell>[[getSub(attachers, item.$key, 'name')]]</paper-cell>
                      <paper-cell>
                        <katapult-drop-down
                          label="Select a Shared Attacher Limit"
                          value="[[item.$val]]"
                          items="[[getItemsArray(_itemData.shared_attacher_limits.*)]]"
                          value-path="$key"
                          label-path="name"
                          no-label-float
                          data-path="_itemData.company_shared_pole_limit.$(model.item.$key)"
                          on-selected-changed="updateProperty"
                        >
                          <paper-row pointer ripple no-user-select on-click="manageSharedAttacherLimits">
                            <paper-cell icon>
                              <material-icon icon="edit"></material-icon>
                            </paper-cell>
                            <paper-cell justify-center>Manage Shared Attacher Limits</paper-cell>
                          </paper-row>
                        </katapult-drop-down>
                      </paper-cell>
                      <paper-cell icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.company_shared_pole_limit.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                    </paper-row>
                  </template>
                  <!-- Add Drop Down -->
                  <paper-row>
                    <paper-cell>
                      <katapult-drop-down
                        label="Select a Company"
                        value="[[item.$key]]"
                        items="[[attachers]]"
                        value-path="$key"
                        label-path="name"
                        no-label-float
                        data-path="_itemData.company_shared_pole_limit.$(detail.value)"
                        data-value=""
                        on-selected-changed="selectedChangedCallback"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </div>
          </paper-row>
          <!-- Submission Groups -->
          <paper-row expand>
            <div flex grow style="padding: 12px; gap: 24px;">
              <material-icon icon="group_work"></material-icon>
              <div flex column grow style="gap: 12px;">
                <div flex align-center style="height: 24px;">Submission Groups</div>
                <div>
                  Groups of applications to keep track of submission counts. The filter logic for these groups must be mutually exclusive
                  (an app should not be able to pass the filter on more than 1 submission group). <b>Note</b>: If there is at least 1
                  submission group and an app does not pass the filter for any groups, it will be put in a default submission group.
                </div>
                <paper-table rounded white outline grow overflow-hidden dividers>
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getItemsArray(_itemData.submission_groupings.*)]]" mutable-data>
                    <paper-header-content
                      data-path="_itemData.submission_groupings.$(model.item.$key)"
                      on-opened-changed="updateProperty"
                      on-render-changed="updateProperty"
                      opened="[[item.$opened]]"
                      divider
                      no-click-row
                    >
                      <paper-cell slot="header" input>
                        <paper-input
                          label="Name"
                          value="[[item.name]]"
                          data-path="_itemData.submission_groupings.$(model.item.$key).name"
                          no-label-float
                          on-value-changed="updateProperty"
                        ></paper-input>
                      </paper-cell>
                      <paper-cell slot="header-end" icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.submission_groupings.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                      <template is="dom-if" if="[[item.$render]]" restamp>
                        <div class="settings-table" slot="content" flex column>
                          <paper-row>
                            <paper-cell icon>
                              <material-icon icon="functions"></material-icon>
                            </paper-cell>
                            <paper-cell shrink>Application Filter</paper-cell>
                            <paper-cell>
                              <k-logic-editor
                                block="[[item.app_filter]]"
                                schema="[[_klogicSchemas.submissionGroups]]"
                                data-path="_itemData.submission_groupings.$(model.item.$key).app_filter"
                                on-block-changed="updateProperty"
                              ></k-logic-editor>
                            </paper-cell>
                          </paper-row>
                        </div>
                      </template>
                    </paper-header-content>
                  </template>
                  <!-- Add Button -->
                  <paper-row class="addButton" light-grey short data-path="_itemData.submission_groupings" on-click="addItem">
                    <paper-cell justify-center>
                      <paper-ripple></paper-ripple>
                      <material-icon icon="add_circle_outline"></material-icon>
                      <div>Add an Submission Group</div>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </div>
          </paper-row>
          <!-- Utility Regions -->
          <paper-row expand>
            <div flex grow style="padding: 12px; gap: 24px;">
              <material-icon icon="map"></material-icon>
              <div flex column grow style="gap: 12px;">
                <div flex align-center style="height: 24px;">Regions</div>
                <div>Geographic regions or operations centers which can modify the behavior of applications created within them.</div>
                <div flex align-center style="gap: 8px;">
                  <katapult-icon icon="sync" size="small"></katapult-icon>
                  <div>
                    These regions auto-populate the default picklist of the
                    <a href$="[[_getAttributeLink(modelSpaceDetails.$key, 'region')]]" target="_blank" class="highlighted-link">Region</a>
                    attribute.
                  </div>
                </div>
                <paper-table rounded white outline grow overflow-hidden dividers>
                  <!-- Header -->
                  <paper-row grey short>
                    <paper-cell>Region Name</paper-cell>
                  </paper-row>
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getItemsArray(_itemData.regions.*)]]" mutable-data>
                    <paper-header-content
                      data-path="_itemData.regions.$(model.item.$key)"
                      on-opened-changed="updateProperty"
                      on-render-changed="updateProperty"
                      opened="[[item.$opened]]"
                      divider
                      no-click-row
                    >
                      <paper-cell slot="header" input>
                        <paper-input
                          label="Name"
                          value="[[item.name]]"
                          data-path="_itemData.regions.$(model.item.$key).name"
                          no-label-float
                          on-value-changed="updateProperty"
                        ></paper-input>
                      </paper-cell>
                      <paper-cell slot="header-end" icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.regions.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                      <template is="dom-if" if="[[item.$render]]" restamp>
                        <div class="settings-table" slot="content" flex column>
                          <paper-row>
                            <paper-cell icon>
                              <katapult-icon icon="supervisor_account"></katapult-icon>
                            </paper-cell>
                            <paper-cell shrink>Region Utility Admins</paper-cell>
                            <paper-cell column align-start style="gap: 8px;">
                              <div flex align-center style="gap: 24px;">
                                <katapult-drop-down
                                  items="[[utilityCompanyUsers]]"
                                  value-path="$key"
                                  label="Select User"
                                  label-path="email"
                                  select-on-focus
                                  no-label-float
                                  show-last-results
                                  class="short-dropdown"
                                  prevent-selection
                                  data-path="_itemData.regions.$(model.item.$key).utility_admins"
                                  on-selected-will-change="handleAdminSelected"
                                ></katapult-drop-down>
                                <div italic>Assign utility company admins to manage apps in this region.</div>
                              </div>
                              <div flex style="gap: 4px;">
                                <template is="dom-repeat" items="[[item.utility_admins]]" as="attacherUtilityAdmin" mutable-data>
                                  <div class="label-item" style$="[[_computeLabelItemStyle(attacherUtilityAdmin)]]">
                                    <div>[[getSub(utilityCompanyUsers, attacherUtilityAdmin, 'email')]]</div>
                                    <katapult-icon
                                      icon="clear"
                                      size="small"
                                      style="cursor: pointer;"
                                      data-path="_itemData.regions.$(model.parentModel.item.$key).utility_admins"
                                      on-click="removeArrayItem"
                                    ></katapult-icon>
                                  </div>
                                </template>
                                <template is="dom-if" if="[[!item.utility_admins.length]]">
                                  <div italic>(No utility admins have been added)</div>
                                </template>
                              </div>
                            </paper-cell>
                          </paper-row>
                        </div>
                      </template>
                    </paper-header-content>
                  </template>
                  <!-- Add Button -->
                  <paper-row class="addButton" light-grey short data-path="_itemData.regions" on-click="addItem">
                    <paper-cell justify-center>
                      <paper-ripple></paper-ripple>
                      <material-icon icon="add_circle_outline"></material-icon>
                      <div>Add a Region</div>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </div>
          </paper-row>
          <!-- Timeline Dates (eventually will be replaced by action tracking dates, maybe) -->
          <paper-row expand>
            <div flex grow style="padding: 12px; gap: 24px;">
              <material-icon icon="event_note"></material-icon>
              <div flex column grow style="gap: 12px;">
                <div flex align-center style="height: 24px;">Timeline Dates</div>
                <!-- TODO (06-14-2023): Add an explanation of this setting -->
                <paper-table rounded white outline grow overflow-hidden dividers style="width: 600px;">
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getItemsArray(_itemData.timeline_dates.*)]]" mutable-data>
                    <paper-row>
                      <paper-cell>[[camelCase(item.$key)]]</paper-cell>
                      <paper-cell icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.timeline_dates.$(model.item.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                    </paper-row>
                  </template>
                  <!-- Add Drop Down -->
                  <paper-row>
                    <paper-cell>
                      <katapult-drop-down
                        label="Attribute"
                        value="[[item.attribute]]"
                        value-path="$key"
                        label-path="$key"
                        label-function="[[camelCase]]"
                        items="[[otherAttributes]]"
                        no-label-float
                        data-path="_itemData.timeline_dates.$(detail.value)"
                        data-value="$true"
                        on-selected-changed="selectedChangedCallback"
                      ></katapult-drop-down>
                    </paper-cell>
                  </paper-row>
                </paper-table>
              </div>
            </div>
          </paper-row>
        </paper-table>
      `;
    }

    constructor() {
      super();

      this.optionsForAppAdministration = [
        { value: 'NONE', label: 'None (default)' },
        { value: 'REGION', label: 'Region' },
        { value: 'ATTACHER', label: 'Attacher' },
        { value: 'REGION_AND_ATTACHER', label: 'Region and Attacher' }
      ];

      this._computeLabelItemStyle = (label) =>
        safeHtml`background-color: ${randomColor({ seed: label, luminosity: 'light', alpha: 0.5, format: 'rgba' })};`;
      this._getAttributeLink = (modelSpace, attribute) => `#${modelSpace}/attributes/${attribute}`;
    }

    ready() {
      super.ready();
      this.appConfiguration = new AppConfiguration(this);

      this._klogicSchemas = {
        contractorAssignment: {
          metadata: DEFAULT_SCHEMAS.JOB.metadata,
          nodes: DEFAULT_SCHEMAS.JOB.nodes,
          attacher: 'object',
          attacher_labels: 'list'
        },
        submissionGroups: {
          metadata: DEFAULT_SCHEMAS.JOB.metadata,
          nodes: DEFAULT_SCHEMAS.JOB.nodes
        },
        deploymentMap: {
          metadata: DEFAULT_SCHEMAS.JOB.metadata,
          companyId: 'string'
        }
      };
    }

    updateTopLevelInput(e) {
      let dataPath = e.currentTarget?.dataset?.path;
      // Don't update values from top level inputs until _itemData is set
      if (this._itemData && dataPath && e?.detail) {
        this.set(dataPath, e.detail.value);
      }
    }

    manageSharedAttacherLimits() {
      this.$.limitsDialog.open();
    }

    selectedChangedCallback(e) {
      // Make sure event detail is not nullish, and if not, update the property and clear the drop down.
      if (e?.detail?.value !== '' && e?.detail?.value != null) {
        this.updateProperty(e);
        e.currentTarget.clear();
      }
    }

    addObjectItem(e) {
      if (e?.detail?.value !== '' && e?.detail?.value != null) {
        const path = this.getDataPath(e);
        this.updateProperty(new CustomEvent('add-item', { detail: { path, value: { _exists: true } } }));
        e.currentTarget.clear();
      }
    }

    pushArrayItem(path, item) {
      const array = this.get(path) ?? [];
      // Don't add the item if it's already in the array or it is falsy
      if (array.includes(item) || !item) return;
      array.push(item);
      this.updateProperty({ detail: { path, value: array } });
    }

    handleLabelInputKeydown(e) {
      if (e.key === 'Enter') {
        this.pushArrayItem(this.getDataPath(e), e.currentTarget.value);
        e.currentTarget.value = '';
      }
    }

    handleAdminSelected(e) {
      this.pushArrayItem(this.getDataPath(e), e.detail.value);
      e.currentTarget.preventSelection = true;
    }

    removeArrayItem(e) {
      const path = this.getDataPath(e);
      const labelArray = this.get(path) ?? [];
      labelArray.splice(e.model.index, 1);
      this.updateProperty({ detail: { path, value: labelArray } });
    }

    async beforeSave() {
      const cancelSaveProcess = await confirmSyncPortalConfig(this.modelSpaceDetails.$key);
      if (cancelSaveProcess) throw new Error('User did not confirm sync portal config');
    }

    async afterSave() {
      await syncPortalConfigs(this.modelSpaceDetails.$key);
      // Set any attributes whose configuration is dependent on the portal user options
      this.#updateContractorAttributePicklists();
      this.#updateRegionAttributePicklist();
    }

    #updateContractorAttributePicklists() {
      const attributesRef = FirebaseWorker.database().ref(`${this.modelSpaceDetails.path}/models/attributes`);

      const attributesToUpdate = [
        ['engineering_contractor', this._itemData.engineering_contractors],
        ['data_collection_contractor', this._itemData.data_collection_contractors],
        ['review_contractor', this._itemData.review_contractors]
      ];

      for (const [attributeName, configData] of attributesToUpdate) {
        const attributeRef = attributesRef.child(attributeName);
        const picklist = Object.values(configData ?? {})
          .filter((x) => Boolean(x))
          .map(({ $key: companyId }) => ({
            value: companyId,
            label: this.companies[companyId]?.name ?? companyId
          }));
        attributeRef.update({
          picklists: { default: picklist },
          last_modified: serverTimestamp()
        });
      }
    }

    #updateRegionAttributePicklist() {
      const attributesRef = FirebaseWorker.database().ref(`${this.modelSpaceDetails.path}/models/attributes`);

      const attributeRef = attributesRef.child('region');
      const picklist = Object.values(this._itemData.regions ?? {})
        .filter((x) => Boolean(x))
        .map(({ name: value }) => ({ value }));
      attributeRef.update({
        picklists: { default: picklist },
        last_modified: serverTimestamp()
      });
    }
  }
);
